<template>
  <div id="form-wrapper">
    <div class="form-header">
      <div class="form-container text-center">
        <icon name="padlock" /> Secure contact tracing
      </div>
    </div>

    <div class="form form-container" v-if="!account.is_service_suspended">
      <a-button v-if="entries.length && view != 'checkins'" @click="view = 'checkins'" size="large" class="full-width margin-bottom-base">🎟️ My check-ins <a-badge :count="entries.length" class="margin-left-sm" /> </a-button>

      <a-button v-if="view == 'checkins'" @click="view = 'form'" class="full-width margin-bottom-sm"><icon name="arrow_left" /> Go back</a-button>

      <div class="form-view form-view-success" v-if="denied_entry">
        <h1>🛑</h1>

        <h3><b>Sorry, you have not passed the screening.</b></h3>

        <h6>You are advised to go home to self-isolate immediately and contact Telehealth Ontario at <b>1 866-797-0000</b> to find out if you need a COVID-19 test.</h6>
      </div>

      <template v-if="!denied_entry">
        <div class="form-view form-view-form" v-if="view == 'form'">
          <template v-if="screening.active">
            <h4>📍 <b>Check in at {{ account.company }}.</b></h4>
            <p class="font-medium">Please complete the following required screening:</p>
          </template>

          <template v-if="!screening.active && !required.active">
            <h4>📍 <b>Check in at {{ account.company }}.</b></h4>
            <p class="font-medium">Please enter your contact information:</p>
          </template>

          <div class="screening margin-top-lg" v-if="screening.active">
            <div class="screening-question">
              <h6 v-html="screening_question.h1"></h6>
              <h4 class="margin-top-base">{{ screening_question.h2 }}</h4>

              <div class="form-toggle">
                <a-row type="flex" align="middle" class="text-center">
                  <a-col :span="11">
                    <a-button @click="answer_question(true)" size="large" class="full-width"><b>Yes</b></a-button>
                  </a-col>
                  <a-col :span="2">
                    <span class="color-gray margin-left-xs margin-right-xs">or</span>
                  </a-col>
                  <a-col :span="11">
                    <a-button @click="answer_question(false)" size="large" class="full-width"><b>No</b></a-button>
                  </a-col>
                </a-row>
              </div>
            </div>
          </div>

          <template v-if="!screening.active && required.active">
            <h4>📍 <b>Check in at {{ account.company }}.</b></h4>
            <p class="font-medium">Please answer the following required questions:</p>
          </template>

          <div class="screening margin-top-lg" v-if="!screening.active && required.active">
            <div class="screening-question">
              <!-- <h6 v-html="get_answer_options(required_question.id)"></h6> -->
              <h4 class="margin-top-base">{{ required_question.question }}</h4>

              <div class="form-toggle" v-if="required_question.question_type == 'true_false'">
                <a-row type="flex" align="middle" class="text-center">
                  <a-col :span="11">
                    <a-button @click="answer_required(required_question.id, true)" size="large" class="full-width"><b>Yes</b></a-button>
                  </a-col>
                  <a-col :span="2">
                    <span class="color-gray margin-left-xs margin-right-xs">or</span>
                  </a-col>
                  <a-col :span="11">
                    <a-button @click="answer_required(required_question.id, false)" size="large" class="full-width"><b>No</b></a-button>
                  </a-col>
                </a-row>
              </div>

              <div class="form-toggle" v-if="required_question.question_type == 'multiple_choice'">
                <a-row type="flex" align="middle" class="text-center">
                  <a-col :span="12" v-for="answer in required_question.screening_options" :key="answer.id" class="padding-top-base">
                    <a-button @click="answer_required(required_question.id, answer.option)" size="large" class="full-width"><b>{{ answer.option }}</b></a-button>
                  </a-col>
                </a-row>
              </div>

              <div class="form-toggle" v-if="required_question.question_type == 'short_answer'">
                <a-form-model class="margin-top-base" @submit.prevent="answer_required(required_question.id, answer.form.text)" ref="answer" :model="answer.form" layout="vertical">

                  <a-form-model-item prop="answer" label="Answer">
                    <a-input
                      size="large"
                      spellcheck="false"
                      v-model="answer.form.text"
                      required="true"
                    />
                  </a-form-model-item>
                  <div class="text-right margin-top-base"> 
                    <a-button htmlType="submit" :loading="answer.saving" size="large" icon="check">Save answer</a-button>
                  </div>
                </a-form-model>
              </div>
            </div>
          </div>

          <a-form-model class="margin-top-base" @submit.prevent="submit" ref="form" :model="form" layout="vertical" v-if="!screening.active && !required.active">

            <div class="form-notice margin-bottom-sm" v-if="pulled_from_cache">
              We still remember you, Just check-in again! <a href="#" @click.prevent="clear_cache(false)"><b>Clear</b></a>
            </div>

            <a-form-model-item prop="contact_name" label="Your name">
              <a-input
                size="large"
                spellcheck="false"
                v-model="form.contact_name"
              />
            </a-form-model-item>

            <a-form-model-item prop="contact_phone" label="Your phone number" class="no-margin" v-if="form.contact_method == 'phone'">
              <a-input
                size="large"
                spellcheck="false"
                inputmode="tel"
                v-model="form.contact_phone"
              >

                <a-icon slot="prefix" type="phone" class="fade-40" />
              </a-input>
            </a-form-model-item>

            <a-form-model-item prop="contact_email" label="Your email address" class="no-margin" v-else>
              <a-input
                size="large"
                spellcheck="false"
                inputmode="email" 
                v-model="form.contact_email"
              >
              </a-input>
            </a-form-model-item>

            <div class="margin-top-xs">
              <a href="#" @click.prevent="form.contact_method = 'email'" v-if="form.contact_method == 'phone'"><span class="color-gray">I don't have a number</span></a>

              <a href="#" @click.prevent="form.contact_method = 'phone'" v-if="form.contact_method == 'email'"><span class="color-gray">I don't have an email</span></a>
            </div>

            <template v-if="this.waiver_data.has_waiver">

              <a-form-model-item prop="waiver" label="Waiver" class="margin-top-sm">
                <WebViewer :path="`${publicPath}lib`" :url="`${this.waiver_data.waiver_url}`"/>
              </a-form-model-item>
              
              <div class="margin-top-sm">
                <span class="color-gray">Please Sign in Center of The Box Below </span>
              </div>
            
              <div class="margin-top-sm">
                <VueSignaturePad
                  id="signature"
                  width="100%"
                  height="100px"
                  ref="signaturePad"
                  :options="options"
                />
              </div>

              <div class="margin-top-sm">
                <div class="filters">
                  <div class="filters-content">
                    <a-button size="large" @click="undo"><icon name="undo" /> Undo</a-button>
                  </div>
                  <div class="filters-sider">
                    <a-checkbox @change="onChange" class="margin-top-sm">I agree</a-checkbox>
                  </div>
                </div>

              </div>
            </template>

            <a-button htmlType="submit" class="full-width margin-top-sm" :loading="saving" type="primary" icon="check" size="large"> <b> Check in now</b></a-button>


            <a-button @click="open_menu" v-if="account.menu_url && is_menu_unlocked" icon="unordered-list" size="large" class="full-width margin-top-sm margin-bottom-xs"> <b> View our Menu!</b></a-button>

          </a-form-model>
        </div>

        <div class="form-view form-view-success" v-if="view == 'success'">
          <svg class="animated-checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="animated-checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="animated-checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>

          <h3><b>Thank you {{ form.contact_name.split(' ')[0] }}!</b></h3>
          <h6>Your check-in has been logged.</h6>

          <div class="checkin billboard margin-bottom-sm" v-if="false && last_entry">
            <h4>
              <svg class="animated-checkmark" style="width: 32px; height: 32px; margin: -8px 5px 0 0; vertical-align: middle;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="animated-checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="animated-checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>

               <b>{{ (last_entry.contact_name || '').split(' ')[0] }}</b></h4>
            <h6>{{ format_time(last_entry.checkin_at) }}</h6>

            <p class="no-margin">{{ account.company }}</p>
          </div>


          <a-button @click="open_menu" v-if="account.menu_url" size="large" icon="unordered-list" type="primary" class="full-width margin-top-sm margin-bottom-base"> <b> View our Menu!</b> <a-badge :number-style="{backgroundColor: 'transparent'}" :count="menu_countdown" class="margin-left-sm" /></a-button>

          <a-button @click="clear_cache" size="large" icon="plus" :type="account.menu_url ? null : 'primary'" class="full-width margin-top-sm margin-bottom-xs">Check in for someone else</a-button>
          <div class="color-gray font-sm">OR</div> 
          <a-button @click="reset_form" icon="reload" class="full-width margin-top-xs">Check in again</a-button>
        </div>


        <div class="form-view form-view-success" v-if="view == 'checkins'">

          <div class="checkins">
            <div class="checkin billboard margin-bottom-sm animate-slight-rise-up" :style="{'animation-delay': i*100 + 'ms'}" style="margin-top: 0" v-for="(entry, i) in entries" :key="entry.id">
              <h4>

              <svg class="animated-checkmark" style="width: 32px; height: 32px; margin: -8px 5px 0 0; vertical-align: middle;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="animated-checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="animated-checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>

               <b>{{ (entry.contact_name || '').split(' ')[0] }}</b></h4>
              <h6>{{ format_time(entry.checkin_at) }}</h6>

              <p class="no-margin">{{ account.company }}</p>
            </div>
          </div>

          <a-button @click="reset_form" icon="reload" class="full-width margin-top-xs" size="large" type="primary">Check-in again</a-button>
        </div>


        <div class="billboard" v-if="view == 'form'">
          <img src="../../images/shield.png" width="60" srcset="../../images/shield.png 1x, ../../images/shield@2x.png 2x" class="shield"/>

          <h6>Why we need this information?</h6>
          <!-- <p>Due to covid-19, spaces like ours are required to collect patrons' contact information for contact tracing purposes.</p>

          <p class="no-margin">Your data is never used for marketing and deleted after {{ account.data_ttl }} days.</p> -->
        </div>
      </template>

    </div>

    <div class="form-container text-center padding-top-base padding-bottom-base" v-else>
      <h2>⚠️</h2>
      <h4><b>Service is paused.</b></h4>

      <p>Contact tracing for {{ account.company }} has been paused.</p>

      <p>If you are the owner of this business please contact us&nbsp;<a href="mailto:contact@mvtechnologies.ca">here</a>.</p>
    </div>

    <footer class="footer">
      <a href="https://guestlog.co">
        <icon name="logo_symbol" class="footer-logo" size="18" />
        powered by GuestLog
      </a>


      <a href="https://guestlog.co/privacy">
        <icon name="padlock" size="18" />
        Privacy policy
      </a>
    </footer>
  </div>
</template>


<script>
import '../../css/4-vendors/antd_form.less'
import '../../css/form.scss'
import WebViewer from './WebViewer.vue'

const lscache = require('lscache')

export default {
  props: [],

  components: { 
    WebViewer
   },

  data(){
    return {
      account: window._prefetch_data.account,
      waiver_data: window._prefetch_data.waiver_data,
      questions_data: window._prefetch_data.questions_data,
      form: {},
      view: 'form',
      error: null,
      saving: false,

      pulled_from_cache: false,

      entries: [],
      last_entry: null,

      menu_countdown: 0,

      is_menu_unlocked: false,

      screening: {
        active: false,
        step: 0,
      },

      required: {
        active: false,
        step: 0,
      },

      fetching: false,

      answer_options: [],

      answer: {
        form: {},
        saving: false
      },

      screening_answers: [],

      denied_entry: false,

      options: {
        penColor: "#202020"
      },

      publicPath: process.env.BASE_URL,

      checked: false
    }
  },

  created(){
    this.$axios.defaults.headers.common['X-CSRF-Token'] = (document.querySelector('meta[name=csrf-token]') || {}).content
    
    // this.reset_screening()
    this.reset_form()
    this.fetch_entries()

    this.is_menu_unlocked = lscache.get(`menu_unlocked:${this.account.id}`) ? true : false

    console.log(this.questions_data)
  },

  methods: {
    answer_question(a){
      this.screening_question.v = a 

      if(this.screening.questions[this.screening.question_ix+1]){
        this.screening.question_ix += 1
      }else{
        if(this.screening.questions.find((q) => { return q.v === true })){
          this.denied_entry = true
        }else{
          this.screening.active = false
        }
      }
    },

    get_answer_options(id){
      this.$axios.get(`/${this.account.subdomain}/questions/${id}/options`).then ((rsp) => {
        
        this.$set(this, 'answer_options', rsp.data.data)
        console.log(this.answer_options)
      })
    },

    answer_required(id=null, answer=null){
      this.screening_answers.push({
        screening_question_id: id,
        answer: answer
      })

      if(this.required.questions[this.required.question_ix+1]){
        this.required.question_ix += 1
        this.$set(this, 'answer', {
          form: {
            text: null
          },
        })
      }else{
        // if(this.screening.questions.find((q) => { return q.v === true })){
        //   this.denied_entry = true
        // }else{
          this.required.active = false
        // }
      }
    },

    reset_screening(){
      let q1 = "<b>1.</b> Do you have any of the following <b>new or worsening</b> symptoms or signs? <i>Symptoms should not be chronic or related to other known causes or conditions.</i>"

      //  { h1: q1, h2: 'Runny nose/stuffy nose or nasal congestion?', v: null },
      
      this.$set(this, 'screening', {
        active: this.account.screening_region == 'CA',
        question_ix: 0,
        questions: [
          { h1: q1, h2: 'Fever or chills?', v: null },
          { h1: q1, h2: 'Difficulty breathing or shortness of breath?', v: null },
          { h1: q1, h2: 'Cough?', v: null },
          { h1: q1, h2: 'Sore throat, trouble swallowing?', v: null },
          { h1: q1, h2: 'Runny or Stuffy nose', v: null },
          { h1: q1, h2: 'Headache that is unusual or long lasting', v: null },
          { h1: q1, h2: 'Conjunctivitis (pink eye)', v: null },
          { h1: q1, h2: 'Decreased or lack of Appetite', v: null },
          { h1: q1, h2: 'Decreased or loss of smell or taste?', v: null },
          { h1: q1, h2: 'Nausea, vomiting,  diarrhea, abdominal pain?', v: null },
          { h1: q1, h2: 'Not feeling well, extreme tiredness, sore muscles?', v: null },
          { h1: '<b>2.</b> <b>Are you currently on a government mandated quarantine?</b>', v: null },
          { h1: '<b>3.</b> <b>Have you had close contact with a confirmed or probable case of COVID-19?</b>', v: null },
          { h1: '<b>4.</b> <b>In the last 14 days, have you or someone you live with travelled outside of Canada AND been advised to quarantine (as per federal quarantine requirements)?</b>', v: null },
          { h1: '<b>5.</b> <b>In the last 10 days, have you tested positive on a rapid antigen test or a home-based self-testing kit?</b>', v: null },
          { h1: '<b>6.</b> <b>In the last 10 days, have you received a COVID Alert exposure notification on your cell phone?</b>', v: null },
          { h1: '<b>7.</b> <b>In the last 10 days, has someone you live with been identified as a “close contact” of someone who currently has COVID-19 AND advised by a doctor, healthcare provider or public health unit to self-isolate?</b>', v: null },
          { h1: '<b>8.</b> <b>Is anyone you live with currently experiencing any new COVID-19 symptoms and/or waiting for test results after experiencing symptoms?</b>', v: null },
        ]
      })

      this.$set(this, 'required', {
        active: this.questions_data.has_questions,
        question_ix: 0,
        questions: this.questions_data.questions
      })
    },

    open_menu(){
      window.location = this.account.menu_url
    },

    format_time(s){
      return new Date(s).toLocaleString()
    },

    fetch_entries(){
      try{
        let entries = lscache.get(`entries:${this.account.id}`) || []

        entries = _.take(_.filter(entries, (ent) => {
          return !ent.checkin_at || (+new Date() - +new Date(ent.checkin_at)) < 1000*60*60*12
        }), 20)

        lscache.set(`entries:${this.account.id}`, entries)

        this.entries = entries
      }catch(err){
        console.log(err) 
      }
    },

    cache_entry(entry){
      try{
        let entries = lscache.get(`entries:${this.account.id}`) || []
        entries.unshift(entry)
        lscache.set(`entries:${this.account.id}`, entries)
      }catch(err){
        console.log(err) 
      }

      this.fetch_entries()
    },

    clear_cache(reset_form=false){
      lscache.remove('form:contact_name')
      lscache.remove('form:contact_email')
      lscache.remove('form:contact_phone')
      this.pulled_from_cache = false

      this.$set(this, 'form', {
        contact_name: null,
        contact_email: null,
        contact_phone: null,
        contact_method: 'phone'
      })

      if(reset_form){
        this.reset_form()
      }
    },

    reset_form(){
      this.reset_screening()
      this.answers = []

      if(lscache.get('form:contact_name')){
        this.pulled_from_cache = true
      }

      this.$set(this, 'form', {
        contact_name: lscache.get('form:contact_name') || null,
        contact_email: lscache.get('form:contact_email') || null,
        contact_phone: lscache.get('form:contact_phone') || null,
        contact_method: lscache.get('form:contact_email') ? 'email' : 'phone'
      })

      this.view = 'form'
    },

    submit(){
      if(this.saving){ return }

      if(this.waiver_data.waiver_url) {
        if(!this.checked) {
          this.render_error("Please check the box above")
          return
        }

        const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

        if (isEmpty) {
          this.render_error("Please sign in center of the box above ")
          return
        }
        this.form.signature = data
      }

      console.log(this.screening_answers)

      this.form.screening_answers = this.screening_answers

      this.saving = true

      this.$axios.post(`/${this.account.subdomain}/checkin`, this.form).then((rsp) => {
        this.saving = false

        rsp = rsp.data

        // this.articulate_error(rsp)

        if(rsp.status.code == 200){
          this.view = 'success'

          lscache.set('form:contact_name', this.form.contact_name, this.account.data_ttl * 24 * 60)
          lscache.set('form:contact_phone', this.form.contact_phone, this.account.data_ttl * 24 * 60)
          lscache.set('form:contact_email', this.form.contact_email, this.account.data_ttl * 24 * 60)

          this.last_entry = rsp.data
          this.cache_entry(rsp.data)

          this.is_menu_unlocked = true
          lscache.set(`menu_unlocked:${this.account.id}`, 1, 6 * 60)

          if(this.account.menu_url){
            this.menu_countdown = 9

            this.menu_int = setInterval(() => {
              this.menu_countdown -= 1

              if(this.menu_countdown == 0){
                this.open_menu()
                clearInterval(this.menu_int)
              }
            }, 1000)
          }
        } else {
          this.render_error(rsp.status.message)
        }
      }).catch((err) => {
        this.render_error()
      })
    },

    onChange(e) {
     this.checked = e.target.checked;
    },

    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

      alert("Open DevTools see the save data.");
      console.log(isEmpty);
      console.log(data);
    },
  },

  mounted(){
  },

  computed: {
    screening_question(){
      return this.screening.questions[this.screening.question_ix] 
    },

    required_question() {
      return this.required.questions[this.required.question_ix]
    }
  },

  watch: {
    view: function(nv){
      window.scrollTo({ top: 0, behavior: 'smooth' })

      if(nv != 'success' && this.menu_int){
        clearInterval(this.menu_int)
      }
    },
  }
}

</script>

<style>
#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #808080, #ff6737);
  background-origin: border-box;
  background-clip: content-box, border-box;
}
</style>